var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_15598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 33.75H47.5M30 33.75V60M16.25 27.5V16.25H13.32C11.6551 16.25 10.0375 16.804 8.72214 17.8247C7.40679 18.8454 6.46845 20.2747 6.055 21.8875L1.25 40.625V41.25H18.75V45C18.75 48.75 18.75 51.25 20.625 55C20.625 55 22.5 58.75 25 58.75M43.75 27.5V16.25H46.68C48.3449 16.25 49.9625 16.804 51.2779 17.8247C52.5932 18.8454 53.5315 20.2747 53.945 21.8875L58.75 40.625V41.25H41.25V45C41.25 48.75 41.25 51.25 39.375 55C39.375 55 37.5 58.75 35 58.75M15.875 11.25C15.875 11.25 11.875 8.75 11.875 5.625C11.875 4.466 12.3354 3.35448 13.1549 2.53494C13.9745 1.71541 15.086 1.255 16.245 1.255C17.404 1.255 18.5155 1.71541 19.3351 2.53494C20.1546 3.35448 20.615 4.466 20.615 5.625C20.615 8.75 16.625 11.25 16.625 11.25H15.875ZM44.125 11.25C44.125 11.25 48.125 8.75 48.125 5.625C48.125 4.46468 47.6641 3.35188 46.8436 2.53141C46.0231 1.71094 44.9103 1.25 43.75 1.25C41.335 1.25 39.385 3.21 39.385 5.625C39.385 8.75 43.375 11.25 43.375 11.25H44.125Z",
    stroke: "#848484",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_15598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsult);
export default __webpack_public_path__ + "static/media/consult.293bb7fd5853ccb22a9433af2232208b.svg";
export { ForwardRef as ReactComponent };